import { render } from "./windows11.vue?vue&type=template&id=5ad72817&scoped=true&ts=true"
import script from "./windows11.vue?vue&type=script&lang=ts"
export * from "./windows11.vue?vue&type=script&lang=ts"

import "./windows11.vue?vue&type=style&index=0&id=5ad72817&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad72817"]])

export default __exports__